import React, { PropsWithChildren } from 'react';

import Accordion from 'components/Accordion';

import './filters.scss';

interface FilterCategoryProps {
  name: string
}

export default function FilterCategory({
  children,
  name,
}: PropsWithChildren<FilterCategoryProps>) {
  return (
    <Accordion.Item eventKey={name}>
      <Accordion.Header variant="secondary">
        {name}
      </Accordion.Header>
      <Accordion.Body>
        {children}
      </Accordion.Body>
    </Accordion.Item>
  );
}
